var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinscreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-iPhone_14_Pro_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iPhone_14_Pro_3",
    "data-name": "iPhone 14 Pro \\u2013 3",
    clipPath: "url(#clip-iPhone_14_Pro_3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(-16.569 40) rotate(-45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-8 -8)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(8 8)",
    fill: "#39be3c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3",
    "data-name": "Polygon 3",
    d: "M17.589,3.254a3,3,0,0,1,4.821,0l14.044,18.96A3,3,0,0,1,34.044,27H5.956a3,3,0,0,1-2.411-4.786Z",
    transform: "translate(60 40) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_4",
    "data-name": "Polygon 4",
    d: "M17.589,3.254a3,3,0,0,1,4.821,0l14.044,18.96A3,3,0,0,1,34.044,27H5.956a3,3,0,0,1-2.411-4.786Z",
    transform: "translate(20 40)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinscreenIcon);
export default __webpack_public_path__ + "static/media/minscreen-icon.9a575710ba6df1639907bbf8391c73ea.svg";
export { ForwardRef as ReactComponent };